export const removedBudgetCodeMessage = 'The budget code for this funding source has been removed.';
